var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'app-container',
    {
      'app-container_desktop': !_vm.isMobileDevice,
      'app-container_mobile': _vm.isMobileDevice,
    } ],attrs:{"id":"app"}},[_c('topbar'),_vm._v(" "),(_vm.isAuth && !_vm.isMobileDevice)?_c('sidebar'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('vuedal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73c269dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 